import * as config from 'config';
import { ContractDocumentUrlResponse } from 'models/contractDocument';
import { ContractTypes } from 'utils/constants';
import { apiFetch, createQueryUrl, defaultHeaders } from 'utils/fetchUtils';

/**
 * Get MyPages contracts' (like the Terms of Use) URLs in a given language
 */
export async function getContractDocumentUrl(
  contractType: ContractTypes,
  langCode: string,
  countryCode?: string
): Promise<string> {
  const url = createQueryUrl(
    `${config.backendApi}/customers/contracts/${contractType}`,
    { langCode, countryCode }
  );

  const json = await apiFetch<ContractDocumentUrlResponse>(url, {
    headers: {
      ...defaultHeaders
    }
  });

  return json.data.attributes.url;
}
